import {useEffect, useRef} from "react";
import {useUpdateProfileMutation, type VwpAuthUser} from "../store/generated/api";
import {mapI18nLocaleToBackendLanguage} from "../utils/localeUtils";
import {logger} from "../utils/logger";

/**
 * Saves the language the portal shows for users that have none stored, once per page load.
 */
export const usePersistShownLanguageIfUnset = (user: VwpAuthUser | null, shownLocale: string) => {
    const [updateProfile] = useUpdateProfileMutation();
    const saveAttemptedRef = useRef(false);

    useEffect(() => {
        if (!user || user.language || saveAttemptedRef.current) {
            return;
        }
        saveAttemptedRef.current = true;
        updateProfile({
            vwpAuthUserUpdateRequest: {language: mapI18nLocaleToBackendLanguage(shownLocale)}
        }).unwrap().catch((error) => {
            logger.error('Failed to persist language preference:', error);
        });
    }, [user, shownLocale, updateProfile]);
};
